import React, { useState, useEffect } from "react";
import { Bell, Phone, X } from "lucide-react";
import CustomPhoneInput from "./PhoneInput";

const Agentscce = ({ user }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [agents, setAgents] = useState([]);
  const [executives, setExecutives] = useState([]);
  const [formData, setFormData] = useState({
    executiveName: "",
    email: "",
    mobileNumber: "",
    agentId: "",
    password: "",
  });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState({ show: false, message: "", isError: false });

  const showToast = (message, isError = false) => {
    setToast({ show: true, message, isError });
    setTimeout(() => setToast({ show: false, message: "", isError: false }), 3000);
  };

  useEffect(() => {
    const fetchAgents = async () => {
      setLoading(true);
      try {
        const response = await fetch(`${process.env.REACT_APP_SERVER_API}/api/agentslist`);
        if (!response.ok) throw new Error("Failed to fetch agents");
        const data = await response.json();
        setAgents(data);
      } catch (err) {
        setError(err.message);
        showToast("Failed to load agents", true);
      } finally {
        setLoading(false);
      }
    };
    fetchAgents();
  }, []);

  useEffect(() => {
    const fetchExecutives = async () => {
      setLoading(true);
      try {
        const response = await fetch(`${process.env.REACT_APP_SERVER_API}/api/executives?userId=${user.id}&role=${user.role}`);
        if (!response.ok) throw new Error("Failed to fetch executives");
        const data = await response.json();
        setExecutives(data);
      } catch (err) {
        setError(err.message);
        showToast("Failed to load executives", true);
      } finally {
        setLoading(false);
      }
    };
    fetchExecutives();
  }, [user]);





  const validateForm = () => {
    // Check for duplicate email
    if (executives.some(exec => exec.email === formData.email)) {
      showToast("Email already exists", true);
      return false;
    }

    // Check for duplicate mobile number
    if (executives.some(exec => exec.mobileNumber === formData.mobileNumber)) {
      showToast("Mobile number already exists", true);
      return false;
    }

    // Basic email validation
    // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    // if (!emailRegex.test(formData.email)) {
    //   showToast("Invalid email format", true);
    //   return false;
    // }

    // // Mobile number length validation (assuming 10 digits after country code)
    // if (formData.mobileNumber.replace(/\D/g, '').length < 10) {
    //   showToast("Invalid mobile number", true);
    //   return false;
    // }

    return true;
  };









  const handleSubmit = async (e) => {
    e.preventDefault();


    // Validate form before submission
    if (!validateForm()) {
      return;
    }
    setLoading(true);

    const payload = { ...formData, userId: user.id, isActive: true };
    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_API}/api/addexecutive`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
      // if (!response.ok) throw new Error("Failed to add executive");


      // const { executive } = await response.json();
      // setExecutives((prev) => [...prev, executive]);


      const data = await response.json();

      if (!response.ok) {
        // Handle MongoDB duplicate key error
        if (data.error?.includes("E11000")) {
          if (data.error.includes("email_1")) {
            throw new Error("Email already exists");
          }
          if (data.error.includes("mobileNumber_1")) {
            throw new Error("Mobile number already exists");
          }
          throw new Error("Duplicate entry exists");
        }
        throw new Error(data.message || data.error || "Failed to add executive");
      }

      setExecutives((prev) => [...prev, data.executive]);

      setFormData({ executiveName: "", email: "", mobileNumber: "", agentId: "", password: "" });
      setIsModalOpen(false);
      setError(null);
      showToast("Executive added successfully");
    } catch (err) {
      setError(err.message);
      showToast(err.message || "Server error occurred", true);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handlePhoneChange = (phone) => {
    setFormData((prev) => ({
      ...prev,
      mobileNumber: phone,
    }));
  };

  const handleStatusChange = async (executiveId, isActive) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_API}/api/executives/${executiveId}/status`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ isActive }),
      });
      if (!response.ok) throw new Error("Failed to update status");
      setExecutives((prev) =>
        prev.map((exec) => (exec._id === executiveId ? { ...exec, isActive } : exec))
      );
      showToast(`Executive ${isActive ? "activated" : "Inactivated"} successfully`);
    } catch (err) {
      showToast(err.message || "Failed to update status", true);
    }
  };

  return (
    <div className="p-6 bg-gray-100 min-h-full">
      {toast.show && (
        <div
          className={`fixed top-4 right-4 p-4 rounded-md shadow-lg ${toast.isError ? "bg-red-500" : "bg-green-500"
            } text-white`}
        >
          {toast.message}
        </div>
      )}

      {loading && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-white"></div>
        </div>
      )}

      <div className="flex justify-between items-center mb-4">
        <input
          type="text"
          placeholder="Search Calls, Numbers..."
          className="search-bar"
        />
      </div>
      <div style={{ width: "100%", textAlign: "right", marginBottom: "15px" }}>
        <button
          style={{ width: "150px" }}
          className="w-full py-2 text-white bg-blue-600 rounded-md hover:bg-blue-700"
          onClick={() => setIsModalOpen(true)}
          disabled={loading}
        >
          Add Executive
        </button>
      </div>

      <div className="bg-white p-4 rounded-lg shadow-md">
        <table className="w-full border-collapse">
          <thead>
            <tr className="bg-gray-200 text-left">
              <th className="p-2" style={{ textAlign: "center" }}>Sr. No</th>
              <th className="p-2" style={{ textAlign: "center" }}>Agent</th>
              <th className="p-2" style={{ textAlign: "center" }}>Executive Name</th>
              <th className="p-2" style={{ textAlign: "center" }}>Mobile Number</th>
              <th className="p-2" style={{ textAlign: "center" }}>Email ID</th>
              <th className="p-2" style={{ textAlign: "center" }}>Status</th>
            </tr>
          </thead>
          <tbody>
            {executives.map((executive, index) => (
              <tr key={executive._id || index} className="border-b">
                <td className="p-2" style={{ textAlign: "center" }}>{index + 1}</td>
                <td className="p-2" style={{ textAlign: "center" }}>
                  {executive.agent?.name || "N/A"}
                </td>
                <td className="p-2" style={{ textAlign: "center" }}>
                  {executive.executiveName}
                </td>
                <td className="p-2 font-bold" style={{ textAlign: "center" }}>
                  {executive.mobileNumber}
                </td>
                <td className="p-2" style={{ textAlign: "center" }}>{executive.email}</td>
                <td className="p-2" style={{ textAlign: "center" }}>
                  <select
                    value={executive.isActive ? "Active" : "Inactive"}
                    onChange={(e) =>
                      handleStatusChange(executive._id, e.target.value === "Active")
                    }
                    className="border border-gray-300 p-1 rounded-md"
                  >
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 p-4">
          <div className="bg-white p-7 rounded-lg shadow-lg w-116 relative">
            <button
              onClick={() => setIsModalOpen(false)}
              className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
              disabled={loading}
            >
              <X className="w-5 h-5" />
            </button>
            <h2 className="text-lg font-semibold mb-4">Add Executive</h2>
            <form onSubmit={handleSubmit}>
              <input
                name="executiveName"
                placeholder="Name"
                value={formData.executiveName}
                onChange={handleChange}
                className="border border-gray-300 p-3 w-full rounded-md mb-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                required
                disabled={loading}
              />
              <input
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                className="border border-gray-300 p-3 w-full rounded-md mb-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                required
                disabled={loading}
              />
              <CustomPhoneInput
                className="border border-gray-300 p-3 w-full rounded-md mb-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                value={formData.mobileNumber}
                onChange={handlePhoneChange}
                onBlur={() => { }}
                disabled={loading}
              />
              <input
                name="password"
                type="password"
                placeholder="Password"
                value={formData.password}
                onChange={handleChange}
                className="border border-gray-300 p-3 w-full rounded-md mb-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                required
                disabled={loading}
              />
              <select
                name="agentId"
                value={formData.agentId}
                onChange={handleChange}
                className="border border-gray-300 p-3 w-full rounded-md mb-4 focus:outline-none focus:ring-2 focus:ring-blue-400"
                required
                disabled={loading}
              >
                <option value="">Select Agent</option>
                {agents.map((agent) => (
                  <option key={agent._id} value={agent.agentId}>
                    {agent.name}
                  </option>
                ))}
              </select>
              {error && <p className="text-red-500 mb-2">{error}</p>}
              <button
                type="submit"
                className="w-full py-3 text-white bg-blue-600 rounded-md hover:bg-blue-700 transition disabled:bg-gray-400"
                disabled={loading}
              >
                {loading ? "Adding..." : "Add Executive"}
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Agentscce;